import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { WorksProvider } from './contexts/WorksContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute/ProtectedRoute';
import { Layout } from './components/layout/Layout';
import { Login } from './pages/Login/Login';
import Dashboard from "./pages/Dashboard/Dashboard";
import { UsersManagement } from './pages/UsersManagement/UsersManagement';
import { Settings } from './pages/Settings/Settings';
import NoticeManagement from './pages/Noticemanagement/NoticeMangement';

// Works Management Pages
import WorksDashboard from './pages/WorksManagement/WorksDashboard';
import WorksList from './pages/WorksManagement/WorksList';
import WorkForm from './pages/WorksManagement/WorkForm';
import WorkDetails from './pages/WorksManagement/WorkDetails';
import WorksAnalytics from './pages/WorksManagement/Analytics';
import WorksReports from './pages/WorksManagement/WorksReports';

// Territorial Drill-Down
import './index.css';
import MasterDataPage from './pages/MasterDataPage';
import DistrictsList from './components/District-driill-down/DistrictsList';
import PhysicalProgressDashboard from './pages/Dashboard/PhysicalProgressDashboard';
import MasterDataDashboard from './pages/Dashboard/MasterDataDashboard';
import TerritorialDrilldown from './pages/TerritorialDrilldown';
import HierarchicalWorksApp from './pages/HierarchicalWorksApp';
import HierarchicalDrillDown from './pages/HierarchicalDrillDown';
import PReDDashboard from './pages/dashboard/PReDDashboard';
import WasteManagementSystem from './components/wms/WasteManagementSystem';
import WasteAgentApp from './components/wms/WasteAgentApp';
import WasteAgentLogin from './components/wms/WasteAgentlogin';
import WasteAgentloginAdmin from './components/wms/WasteAgentloginAdmin';

// Create a separate component for the routes that uses useNavigate
const AppRoutes: React.FC = () => {
  const navigate = useNavigate();

  const handleLoginSuccess = (agent: any) => {
    console.log('Agent authenticated:', agent);
    localStorage.setItem('wasteAgent', JSON.stringify(agent));
    navigate('/wms');
  };

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/wms" element={<WasteManagementSystem />} />
      <Route path="/wmsapp" element={<WasteAgentApp />} />
      <Route 
        path="/wmsapplogin" 
        element={<WasteAgentLogin onLoginSuccess={handleLoginSuccess} />} 
      />

<Route 
        path="/wmsappadmin" 
        element={<WasteAgentloginAdmin onLoginSuccess={handleLoginSuccess} />} 
      />



      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<UsersManagement />} />
        <Route path="settings" element={<Settings />} />
        <Route path="notices" element={<NoticeManagement />} />
        <Route path="masters" element={<MasterDataPage/>} />

        {/* Works Management Routes */}
        <Route path="works" element={<Navigate to="/works/dashboard" replace />} />
        <Route path="works/dashboard" element={<WorksDashboard />} />
        <Route path="works/list" element={<WorksList />} />
        <Route path="works/drilldown" element={<HierarchicalWorksApp />} />
        <Route path="works/hierarchicaldrilldown" element={<HierarchicalDrillDown />} />
        <Route path="works/PReDDashboard" element={<PReDDashboard />} />
        <Route path="works/analytics" element={<WorksAnalytics />} />
        <Route path="works/reports" element={<WorksReports />} />
        <Route path="works/reports/districts" element={<DistrictsList />} />
        <Route path="works/reports/progressdashboard" element={<PhysicalProgressDashboard />} />
        <Route path="works/reports/MasterDataDashboard" element={<MasterDataDashboard />} />
        <Route path="works/create" element={<WorkForm mode="create" />} />
        <Route path="works/edit/:id" element={<WorkForm mode="edit" />} />
        <Route 
          path="works/view/:id" 
          element={
            <WorkDetails 
              workId={0}
              isOpen={true}
              onClose={() => window.history.back()}
              title="Work Details" 
              children={undefined}                    
            />
          } 
        />

        {/* Catch all - redirect to dashboard */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />                
      </Route>
    </Routes>
  );
};

// Main App component that provides the Router context
const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <NotificationProvider>
          <WorksProvider>
            <AppRoutes />
          </WorksProvider>
        </NotificationProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;